"use client";

import { useContext, useState } from "react";
import { useRouter } from "next/navigation";
import { Box, Dialog, DialogContent, Paper, Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import TokenContext from "@/context/TokenProvider";
import MessageContext from "@/context/MessageProvider";
import MenuContext from "@/context/MenuProvider";
import { StyledTableCell, StyledTableRow } from "@/style/theme/StyledTable";
import useSWR from "swr";
import { genericFetcher } from "@/utils/Fetcher";
import { GenericTableSkeleton } from "@/components/admin/GenericTableSkeleton";
import { GenericDataOutputResponse } from "@/types/shared.types";

interface RekomendasiBuku {
  kodeMatkulBuku: string;
  judul: string;
}

const RekomendasiDialog = () => {
  const { accessToken } = useContext(TokenContext)!;
  const { id, setId } = useContext(MenuContext)!;
  const { setMessage } = useContext(MessageContext)!;
  const { rekomendasiDialog, setRekomendasiDialog } = useContext(MenuContext)!;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const router = useRouter();

  const handleClose = () => {
    setRekomendasiDialog(false);
  };

  const {
    data: buku,
    isLoading: bukuIsLoading
  } = useSWR<GenericDataOutputResponse<RekomendasiBuku>>(`${process.env.NEXT_PUBLIC_API_URL}/rekomendasi/buku/${id}`, genericFetcher);

  return (
    <Dialog
      open={rekomendasiDialog}
      onClose={handleClose}
      fullWidth={true}
      maxWidth={"lg"}
    >
      <DialogContent
        sx={{
          width: "100%"
        }}
      >
        <Box sx={{ width: "100%" }}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">Kode</StyledTableCell>
                  <StyledTableCell align="center">Judul</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {buku && buku.rows.map((row, key) => (
                  <StyledTableRow key={key}>
                    <StyledTableCell align="center">
                      {row.kodeMatkulBuku}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.judul}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
                {bukuIsLoading && <GenericTableSkeleton rows={rowsPerPage} cols={2}/>}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default RekomendasiDialog;
